import { render } from "./ImportStock.vue?vue&type=template&id=dd1dbbe4&scoped=true&ts=true"
import script from "./ImportStock.vue?vue&type=script&lang=ts"
export * from "./ImportStock.vue?vue&type=script&lang=ts"

import "./ImportStock.vue?vue&type=style&index=0&id=dd1dbbe4&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd1dbbe4"]])

export default __exports__